import { Box } from "@mui/system";
import CalculationTypesTable from "./CalculationTypesTable";
import CalculationTypesTableHead from "./CalculationTypesTableHead";
import CalculationTypesTableSkeleton from "./CalculationTypesTableSkeleton";
import CreateCalculationType from "./CreateCalculationType/CreateCalculationType";
import EditCalculationType from "./EditCalculationType/EditCalculationType";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../features/userSlice";
import { CalculationTypesEndPointLogic } from "../../../../logic/DataCollection/Unifier/CalculationTypesEndpointLogic";
import { useDispatch } from "react-redux";
import {
  setOpenModalType,
  setSelectedRow,
} from "../../../../features/unifierCalculationTypesSlice";

const CalculationTypes = () => {
  const { openModalType, isCalculationTypesLoading, rowsPerPage } = useSelector(
    (state: any) => state.unifierCalculationTypes,
  );
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  // the redux flag only turns on once the request starts, so the first render
  // of a freshly mounted tab needs its own
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(setOpenModalType(""));
    dispatch(setSelectedRow({}));
  };

  const fetchCalCulationTypes = async () => {
    try {
      await CalculationTypesEndPointLogic.getCollectionTypes(
        oauthTokenHeader,
        dispatch,
      );
    } catch (error) {
      console.error("Error fetching Calculation Types: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!oauthTokenHeader) return;
    fetchCalCulationTypes();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Box sx={{ mb: 1 }}>
        <CalculationTypesTableHead />
        {loading || isCalculationTypesLoading ? (
          <CalculationTypesTableSkeleton rows={rowsPerPage} />
        ) : (
          <>
            <CalculationTypesTable />
          </>
        )}
      </Box>
      {openModalType === "create" && (
        <CreateCalculationType open={true} handleClose={handleCloseModal} />
      )}
      {openModalType === "edit" && (
        <EditCalculationType open={true} handleClose={handleCloseModal} />
      )}
    </>
  );
};

export default CalculationTypes;
